const SapMasterEmployees = () => {
  return (
    <div>
      <p>SapMasterEmployees</p>
    </div>
  )
}

export default SapMasterEmployees
